export default "__VITE_ASSET__BEJMqL0f__"